'use strict';

import {find, register} from '../../../JavaScript/Utils';

const ProductComparisonSection = $el => {
    const toggle = find('[data-nezzo-section-toggle]', $el);
    const toggleItem = find('[data-nezzo-section-toggle-item]', $el);
    // console.log('Hi, section');

    function closePreviousOpenedEl() {
        const currentToggleEl = find('.productcomparison__section-name.open', $el.parentNode);
        const currentToggleItemEl = find('.productcomparison__features-wrapper.open', $el.parentNode);
        if (currentToggleEl) {
            currentToggleEl.classList.remove('open');
        }
        if (currentToggleItemEl) {
            currentToggleItemEl.classList.remove('open');
        }
    }

    toggle.addEventListener('click', () => {
        if (toggle.classList.contains('open')) {
            toggle.classList.remove('open');
            toggleItem.classList.remove('open');
        } else {
            closePreviousOpenedEl();
            toggle.classList.add('open');
            toggleItem.classList.add('open');
        }
    });
};

register('ProductComparisonSection', ProductComparisonSection);
